import React from 'react'
import IncludeSideBar from '../../../Components/Sidebar/IncludeSideBar'


function FailurePromotions() {
  return (
   <IncludeSideBar>
    <div>
        <p>
            Here we are displaying the Failure Promotions
        </p>
    </div>
   </IncludeSideBar>
  )
}

export default FailurePromotions